"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCardHeader = void 0;
var _CardHeader = require("./CardHeader");
// TODO: in v9, move styled() from CardHeader.jsx to here
var StyledCardHeader = _CardHeader.CardHeader;
exports.StyledCardHeader = StyledCardHeader;